/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pri.1.vue?vue&type=template&id=2525d7f0"
import script from "./pri.1.vue?vue&type=script&lang=js"
export * from "./pri.1.vue?vue&type=script&lang=js"
import style0 from "./pri.1.vue?vue&type=style&index=0&id=2525d7f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports